
import EnglishMessages from '../../translations/en_GB.json'
import GermanMessages from '../../translations/de_DE.json'
import FrenchMessage from '../../translations/fr_FR.json'
import SpanishMessage from '../../translations/es_ES.json'
import ItalianMessage from '../../translations/it_IT.json'

export const defaultLocale = "en-GB";

// The locales our app supports. We'll work
// with English-USA and Arabic-Egypt here.
// Feel free to add any locales you want.
export const locales: {[key: string]: {messages: any}} = {
    // English translation message dictionary.
    "en-GB": {
        messages: EnglishMessages,
    },
    "de-DE": {
        messages: GermanMessages,
    },
    "fr-FR": {
        messages: FrenchMessage,
    },
    "es-ES": {
        messages: SpanishMessage,
    },
    "it-IT": {
        messages: ItalianMessage,
    },
};
